

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/PlayAnim')
export default class PlayAnim extends cc.Component {
    @property(cc.Animation)
    animation: cc.Animation = null

    @property(cc.Integer)
    loopTimes: number = 1

    particles: cc.ParticleSystem[] = []

    _isFindParticleSystem = false

    dragBones: dragonBones.ArmatureDisplay[] = []

    onEnable() {
        if(this.animation){
            let clip = this.animation.getClips()
            this.animation.play(clip[0].name);
        }
        
        if (!this._isFindParticleSystem) {
            this.particles = this.node.getComponentsInChildren(cc.ParticleSystem)
            let tmp = this.node.getComponent(dragonBones.ArmatureDisplay)
            if(tmp){
                this.dragBones.push(tmp)
            }
            this.dragBones = this.dragBones.concat(this.node.getComponentsInChildren(dragonBones.ArmatureDisplay).concat())
            this._isFindParticleSystem = true
        }
        let length = this.particles.length
        for (let i = 0; i < length; i++) {
            this.particles[i].resetSystem()
        }
        if(this.dragBones){
            for (let index = 0; index < this.dragBones.length; index++) {
                const element = this.dragBones[index];
                element.playAnimation(element.animationName, this.loopTimes)
            }
        }
    }

    onDisable() {
        this.animation && this.animation.stop()
    }


}
